import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ForgotPassword from './ForgotPassword';
import Login from './Login';
import { useLoginModal, useSetLoginModal } from '../../global/hooks';
import { Modal, PageHeaderLogo } from '../../../ui';

const LoginModal = () => {
  const setLoginModal = useSetLoginModal();
  const { t } = useTranslation();
  const loginOpen = useLoginModal();
  const [forgotPass, setForgotPass] = useState(false)

  const closeLoginModal = useCallback(() => {
    setLoginModal(false);
  }, [setLoginModal]);

  return (
    <Modal
      onClose={closeLoginModal}
      open={loginOpen}
      titleChildren={
        <PageHeaderLogo message={forgotPass ? t('auth.forgotPassword') : t('auth.signIn')} lightBackground />
      }
    >
      {forgotPass ?
        <ForgotPassword onCancel={() => setForgotPass(false)} noHeader />
        : <Login onForgotPass={() => setForgotPass(true)} noHeader onLogginCallBack={closeLoginModal} />}
    </Modal>
  )
}

export default LoginModal;

